// @ts-nocheck
/**
 * トレード画面
 *
 * ゼルヴァンとのカードトレードを行う
 */

import { economyAccount, economyRequest } from '../../lib/economyClient';
import React, { useState, useMemo, useEffect } from 'react';
import {
  generateZelvanOffers,
  executeTradeOffer,
  reserveOffer,
  cancelReservation as cancelReservationLocal,
  checkReservationExpiry,
  executeReservedOffer,
  getMatchingCards,
  checkConditionMatch,
  calculateOfferValue,
  getCardValue,
  OFFER_TYPE_LABELS,
  OFFER_TYPE_ICONS,
  RESERVATION_CONFIG,
  RARITY_ORDER,
} from '../merchant';
import { RARITY_COLORS, RARITY_NAMES } from '../data/constants';
import { ATTRIBUTE_COLORS } from '../../utils/constants';
import { getCardMarketPrice } from '../market/marketEngine';
import { collectionManager } from '../systems/collectionManager';
import { useIsMobile } from '../hooks/useMediaQuery';
import {
  executeTrade as executeTradeServer,
  reserveTrade as reserveTradeServer,
  cancelReservation as cancelReservationServer,
  completeReservation as completeReservationServer,
  isMerchantServerAvailable,
} from '../../lib/useMerchantServer';

// サーバーAPI使用フラグ
const USE_SERVER_API = (() => {
  try {
    return localStorage.getItem('magisp_use_local_merchant') !== 'true';
  } catch {
    return true;
  }
})();

// ========================================
// スタイル定義
// ========================================

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a3a 50%, #0a0a1a 100%)',
    fontFamily: '"Noto Sans JP", "Hiragino Sans", sans-serif',
    color: '#e0e0e0',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    background: 'linear-gradient(90deg, rgba(20,20,50,0.95) 0%, rgba(60,40,20,0.95) 50%, rgba(20,20,50,0.95) 100%)',
    borderBottom: '2px solid #d4a054',
    padding: '12px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0 4px 20px rgba(212,160,84,0.3)',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  backButton: {
    padding: '8px 16px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    background: 'rgba(212,160,84,0.3)',
    color: '#e0e0e0',
    transition: 'all 0.3s ease',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  goldDisplay: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#ffd700',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    gap: '24px',
    padding: '24px',
    maxWidth: '1400px',
    margin: '0 auto',
    width: '100%',
    boxSizing: 'border-box',
  },
  leftPanel: {
    width: '300px',
    flexShrink: 0,
  },
  rightPanel: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  merchantCard: {
    background: 'linear-gradient(135deg, #2a2a3a 0%, #3a3a4a 100%)',
    borderRadius: '16px',
    padding: '20px',
    border: '2px solid #d4a054',
    marginBottom: '16px',
  },
  merchantHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '16px',
  },
  merchantIcon: {
    fontSize: '48px',
    width: '70px',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(212,160,84,0.2)',
    borderRadius: '50%',
  },
  merchantInfo: {
    flex: 1,
  },
  merchantName: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '4px',
  },
  merchantTitle: {
    fontSize: '13px',
    color: '#d4a054',
    marginBottom: '8px',
  },
  greetingBox: {
    background: 'rgba(0,0,0,0.3)',
    borderRadius: '12px',
    padding: '16px',
    fontSize: '14px',
    fontStyle: 'italic',
    color: '#c0c0c0',
    lineHeight: '1.6',
  },
  reservationSection: {
    background: 'linear-gradient(135deg, #2a2a3a 0%, #3a3a4a 100%)',
    borderRadius: '12px',
    padding: '16px',
    border: '2px solid #ff9800',
    marginBottom: '16px',
  },
  reservationTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#ff9800',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  reservationInfo: {
    fontSize: '13px',
    color: '#e0e0e0',
    marginBottom: '8px',
  },
  statsSection: {
    background: 'rgba(0,0,0,0.2)',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '12px',
    color: '#a0a0a0',
  },
  statRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '4px',
  },
  offerGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '16px',
    flex: 1,
    overflowY: 'auto',
    padding: '4px',
  },
  offerCard: {
    background: 'linear-gradient(135deg, #2a2a3a 0%, #3a3a4a 100%)',
    borderRadius: '12px',
    padding: '16px',
    border: '2px solid #4a4a6a',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    position: 'relative',
  },
  offerCardHover: {
    border: '2px solid #d4a054',
    boxShadow: '0 0 15px rgba(212,160,84,0.4)',
    transform: 'translateY(-2px)',
  },
  offerCardCompleted: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
  offerTypeBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: 'bold',
    marginBottom: '12px',
  },
  offerSection: {
    marginBottom: '12px',
  },
  offerSectionTitle: {
    fontSize: '11px',
    color: '#808080',
    marginBottom: '6px',
    textTransform: 'uppercase',
  },
  cardList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  cardListItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    color: '#e0e0e0',
  },
  conditionBadge: {
    display: 'inline-block',
    padding: '4px 8px',
    background: 'rgba(157,76,230,0.3)',
    borderRadius: '4px',
    fontSize: '12px',
    color: '#c4a0ff',
  },
  gambleHidden: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    background: 'rgba(255,215,0,0.1)',
    borderRadius: '8px',
    fontSize: '14px',
    color: '#ffd700',
  },
  // モーダル
  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.85)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalBox: {
    background: 'linear-gradient(135deg, #1a1a3a 0%, #2a2a4a 100%)',
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '90vh',
    overflowY: 'auto',
    border: '2px solid #d4a054',
    boxShadow: '0 0 50px rgba(212,160,84,0.5)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  closeButton: {
    padding: '4px 8px',
    background: 'transparent',
    border: 'none',
    color: '#a0a0a0',
    fontSize: '24px',
    cursor: 'pointer',
    transition: 'color 0.2s',
  },
  detailSection: {
    marginBottom: '20px',
  },
  detailSectionTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#a0a0a0',
    marginBottom: '12px',
    borderBottom: '1px solid rgba(212,160,84,0.3)',
    paddingBottom: '4px',
  },
  detailCardGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
  },
  detailCard: {
    background: 'rgba(0,0,0,0.3)',
    borderRadius: '8px',
    padding: '12px',
    minWidth: '120px',
    textAlign: 'center',
  },
  detailCardName: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '4px',
  },
  detailCardRarity: {
    fontSize: '11px',
    fontWeight: 'bold',
    marginBottom: '4px',
  },
  detailCardCount: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#ffd700',
  },
  actionButtons: {
    display: 'flex',
    gap: '12px',
    marginTop: '20px',
  },
  actionButton: {
    flex: 1,
    padding: '14px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '15px',
    transition: 'all 0.3s ease',
  },
  primaryButton: {
    background: 'linear-gradient(90deg, #4caf50, #66bb6a)',
    color: '#fff',
  },
  secondaryButton: {
    background: 'rgba(100,100,100,0.5)',
    color: '#fff',
  },
  warningButton: {
    background: 'linear-gradient(90deg, #ff9800, #ffc107)',
    color: '#1a1a2e',
  },
  dangerButton: {
    background: 'linear-gradient(90deg, #f44336, #ff5252)',
    color: '#fff',
  },
  disabledButton: {
    background: 'rgba(100,100,100,0.3)',
    color: '#808080',
    cursor: 'not-allowed',
  },
  // 条件カード選択
  cardSelectionGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: '12px',
    maxHeight: '300px',
    overflowY: 'auto',
    padding: '4px',
  },
  selectableCard: {
    background: 'linear-gradient(135deg, #2a2a4a 0%, #3a3a5a 100%)',
    borderRadius: '8px',
    padding: '12px',
    border: '2px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  selectableCardSelected: {
    border: '2px solid #4caf50',
    background: 'linear-gradient(135deg, #2a3a2a 0%, #3a4a3a 100%)',
  },
  selectedCount: {
    textAlign: 'center',
    fontSize: '14px',
    color: '#d4a054',
    margin: '12px 0',
  },
  // 結果モーダル
  resultModal: {
    textAlign: 'center',
  },
  resultIcon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  resultTitle: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: '16px',
  },
  resultCardList: {
    background: 'rgba(0,0,0,0.3)',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
  },
  emptyMessage: {
    textAlign: 'center',
    color: '#808080',
    padding: '48px',
    fontSize: '16px',
  },
};

// ========================================
// オファータイプの色
// ========================================

const OFFER_TYPE_COLORS = {
  equal: { bg: 'rgba(107,76,230,0.3)', text: '#a0a0ff' },
  profitable: { bg: 'rgba(76,175,80,0.3)', text: '#66bb6a' },
  loss: { bg: 'rgba(158,158,158,0.3)', text: '#b0b0b0' },
  attribute: { bg: 'rgba(156,39,176,0.3)', text: '#ce93d8' },
  rare: { bg: 'rgba(255,193,7,0.3)', text: '#ffd54f' },
  gamble: { bg: 'rgba(255,87,34,0.3)', text: '#ff8a65' },
};

// ========================================
// ゼルヴァンの挨拶
// ========================================

const ZELVAN_GREETINGS = [
  'やあ、旅人。良いカードを持っているね。',
  '今日はいい取引ができそうだ。',
  '君のコレクションに興味があるな。',
  '珍しいカードを探しているのかい？',
  'お互いに利益のある取引をしようじゃないか。',
];

// ========================================
// メインコンポーネント
// ========================================

const TradeScreen = ({
  playerData,
  allCards = [],
  cardValueMap = null,
  onBack,
  onPlayerDataUpdate,
}) => {
  const isMobile = useIsMobile();
  const online = !!economyAccount();
  const dayId = online ? playerData?.merchantData?.todayAppearances?.dayId ?? 0 : playerData?.market?.currentDay || 0;

  const [selectedOffer, setSelectedOffer] = useState(null);
  const [cardSelectionModal, setCardSelectionModal] = useState(null);
  const [selectedCards, setSelectedCards] = useState([]);
  const [resultModal, setResultModal] = useState(null);
  const [confirmCancelReservation, setConfirmCancelReservation] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const tradeData = playerData?.tradeData || {};
  const stats = tradeData.stats || {};

  // 市場価格取得関数
  const getMarketPrice = (card, rarity) => {
    if (!playerData?.market || !cardValueMap) return 100;

    const valueInfo = cardValueMap.get(card.id);
    if (!valueInfo) return 100;

    const baseValue = valueInfo.rarityValues?.[rarity] || valueInfo.baseValue || 100;
    const result = getCardMarketPrice(card, baseValue, playerData.market, rarity, valueInfo.tier);
    return result?.price || baseValue;
  };

  useEffect(() => { if (online) economyRequest('merchant/trade/offers').catch(error => setErrorMessage(error.message)); }, [online]);
  // オファー生成・取得
  useEffect(() => {
    if (online) return;
    if (!playerData || !cardValueMap || allCards.length === 0) return;

    // 予約の期限チェック
    const expiryResult = checkReservationExpiry(playerData, dayId);
    if (expiryResult.expired && onPlayerDataUpdate) {
      onPlayerDataUpdate(expiryResult.playerData);
    }

    // 既に今日のオファーがあればスキップ
    if (tradeData.zelvanOffers?.dayId === dayId) return;

    // 新しいオファーを生成
    const newOffers = generateZelvanOffers(
      playerData.collection || [],
      allCards,
      dayId,
      (card, rarity) => getMarketPrice(card, rarity)
    );

    if (onPlayerDataUpdate) {
      onPlayerDataUpdate({
        ...playerData,
        tradeData: {
          ...tradeData,
          zelvanOffers: newOffers,
        },
      });
    }
  }, [dayId, allCards.length, cardValueMap]);

  const offers = tradeData.zelvanOffers?.offers || [];
  const reservedOffer = tradeData.reservedOffer;

  // カード名を取得
  const getCardName = (cardId) => {
    const card = allCards.find(c => c.id === cardId);
    return card?.name || '不明なカード';
  };

  // カードデータを取得
  const getCard = (cardId) => {
    return allCards.find(c => c.id === cardId);
  };

  // 条件テキストを生成
  const getConditionText = (condition) => {
    const parts = [];
    if (condition.attribute) parts.push(`${condition.attribute}属性`);
    if (condition.rarity) parts.push(RARITY_NAMES[condition.rarity] || condition.rarity);
    if (condition.category) parts.push(`【${condition.category}】`);
    if (condition.maxCost !== undefined) parts.push(`コスト${condition.maxCost}以下`);
    return parts.join(' ') || '任意のカード';
  };

  // トレード実行可能かチェック
  const canExecuteTrade = (offer) => {
    if (offer.completed) return false;

    if (offer.giveType === 'specific') {
      // 具体的指定: すべてのカードを所持しているかチェック
      for (const item of offer.give) {
        const owned = playerData.collection?.find(
          c => c.cardId === item.cardId && c.rarity === item.rarity
        );
        if (!owned || owned.quantity < item.count) {
          return false;
        }
      }
      return true;
    } else {
      // 条件指定: 条件にマッチするカードが十分にあるかチェック
      const matching = getMatchingCards(playerData.collection || [], allCards, offer.giveCondition);
      const totalCount = matching.reduce((sum, m) => sum + m.quantity, 0);
      return totalCount >= offer.giveCondition.count;
    }
  };

  // オファー詳細を開く
  const handleOpenOffer = (offer) => {
    setSelectedOffer(offer);
  };

  // トレード実行
  const handleExecuteTrade = async () => {
    if (!selectedOffer || isProcessing) return;

    if (selectedOffer.giveType === 'condition') {
      // 条件指定: カード選択モーダルを開く
      const matching = getMatchingCards(
        playerData.collection || [],
        allCards,
        selectedOffer.giveCondition
      );
      setCardSelectionModal({
        offer: selectedOffer,
        matchingCards: matching,
        requiredCount: selectedOffer.giveCondition.count,
      });
      setSelectedCards([]);
      setSelectedOffer(null);
      return;
    }

    // 具体的指定: 直接実行
    setIsProcessing(true);
    setErrorMessage(null);

    try {
      if (isMerchantServerAvailable()) {
        // サーバーAPI経由でトレード実行
        const response = await executeTradeServer({
          offerId: selectedOffer.id,
          selectedCards: [],
          dayId,
        });

        if (response.success) {
          setResultModal({
            success: true,
            receivedCards: response.received_cards,
            isGamble: selectedOffer.type === 'gamble',
          });
        } else {
          setErrorMessage(response.error || 'トレードに失敗しました');
        }
      } else {
        // ローカルのみで処理
        const result = executeTradeOffer(
          playerData,
          selectedOffer.id,
          [],
          collectionManager,
          allCards
        );

        if (result.success) {
          onPlayerDataUpdate(result.playerData);
          setResultModal({
            success: true,
            receivedCards: result.receivedCards,
            isGamble: selectedOffer.type === 'gamble',
          });
        } else {
          setErrorMessage(result.message);
        }
      }
    } catch (err) {
      console.error('[TradeScreen] handleExecuteTrade error:', err);
      setErrorMessage(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsProcessing(false);
      setSelectedOffer(null);
    }
  };

  // 条件カード選択を確定
  const handleConfirmCardSelection = async () => {
    if (!cardSelectionModal || isProcessing) return;

    setIsProcessing(true);
    setErrorMessage(null);

    try {
      if (isMerchantServerAvailable()) {
        // サーバーAPI経由でトレード実行
        const response = await executeTradeServer({
          offerId: cardSelectionModal.offer.id,
          selectedCards,
          dayId,
        });

        if (response.success) {
          setResultModal({
            success: true,
            receivedCards: response.received_cards,
            isGamble: cardSelectionModal.offer.type === 'gamble',
          });
        } else {
          setErrorMessage(response.error || 'トレードに失敗しました');
        }
      } else {
        // ローカルのみで処理
        const result = executeTradeOffer(
          playerData,
          cardSelectionModal.offer.id,
          selectedCards,
          collectionManager,
          allCards
        );

        if (result.success) {
          onPlayerDataUpdate(result.playerData);
          setResultModal({
            success: true,
            receivedCards: result.receivedCards,
            isGamble: cardSelectionModal.offer.type === 'gamble',
          });
        } else {
          setErrorMessage(result.message);
        }
      }
    } catch (err) {
      console.error('[TradeScreen] handleConfirmCardSelection error:', err);
      setErrorMessage(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsProcessing(false);
      setCardSelectionModal(null);
      setSelectedCards([]);
    }
  };

  // カード選択トグル
  const toggleCardSelection = (item) => {
    const key = `${item.cardId}_${item.rarity}`;
    const existing = selectedCards.find(
      s => s.cardId === item.cardId && s.rarity === item.rarity
    );

    if (existing) {
      setSelectedCards(selectedCards.filter(
        s => !(s.cardId === item.cardId && s.rarity === item.rarity)
      ));
    } else if (selectedCards.length < cardSelectionModal.requiredCount) {
      setSelectedCards([...selectedCards, { cardId: item.cardId, rarity: item.rarity }]);
    }
  };

  // 予約
  const handleReserve = async () => {
    if (!selectedOffer || isProcessing) return;

    setIsProcessing(true);
    setErrorMessage(null);

    try {
      if (isMerchantServerAvailable()) {
        // サーバーAPI経由で予約
        const response = await reserveTradeServer({
          offerId: selectedOffer.id,
          dayId,
        });

        if (response.success) {
        } else {
          setErrorMessage(response.error || '予約に失敗しました');
        }
      } else {
        // ローカルのみで処理
        const result = reserveOffer(
          playerData,
          selectedOffer.id,
          dayId,
          allCards,
          (card, rarity) => getMarketPrice(card, rarity)
        );

        if (result.success) {
          onPlayerDataUpdate(result.playerData);
        } else {
          setErrorMessage(result.message);
        }
      }
    } catch (err) {
      console.error('[TradeScreen] handleReserve error:', err);
      setErrorMessage(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsProcessing(false);
      setSelectedOffer(null);
    }
  };

  // 予約キャンセル
  const handleCancelReservation = async () => {
    if (isProcessing) return;

    setIsProcessing(true);
    setErrorMessage(null);

    try {
      if (isMerchantServerAvailable()) {
        // サーバーAPI経由でキャンセル
        const response = await cancelReservationServer();

        if (response.success) {
        } else {
          setErrorMessage(response.error || 'キャンセルに失敗しました');
        }
      } else {
        // ローカルのみで処理
        const result = cancelReservationLocal(playerData);
        if (result.success) {
          onPlayerDataUpdate(result.playerData);
        } else {
          setErrorMessage(result.message);
        }
      }
    } catch (err) {
      console.error('[TradeScreen] handleCancelReservation error:', err);
      setErrorMessage(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsProcessing(false);
      setConfirmCancelReservation(false);
    }
  };

  // 予約オファーを実行
  const handleExecuteReservedOffer = async () => {
    if (!reservedOffer || isProcessing) return;

    const offer = reservedOffer.offer;

    if (offer.giveType === 'condition') {
      const matching = getMatchingCards(
        playerData.collection || [],
        allCards,
        offer.giveCondition
      );
      setCardSelectionModal({
        offer: { ...offer, isReservation: true },
        matchingCards: matching,
        requiredCount: offer.giveCondition.count,
      });
      setSelectedCards([]);
      return;
    }

    setIsProcessing(true);
    setErrorMessage(null);

    try {
      if (isMerchantServerAvailable()) {
        // サーバーAPI経由で予約トレード実行
        const response = await completeReservationServer({
          selectedCards: [],
        });

        if (response.success) {
          setResultModal({
            success: true,
            receivedCards: response.received_cards,
            isGamble: offer.type === 'gamble',
          });
        } else {
          setErrorMessage(response.error || '予約トレードの実行に失敗しました');
        }
      } else {
        // ローカルのみで処理
        const result = executeReservedOffer(
          playerData,
          [],
          collectionManager,
          allCards
        );

        if (result.success) {
          onPlayerDataUpdate(result.playerData);
          setResultModal({
            success: true,
            receivedCards: result.receivedCards,
            isGamble: offer.type === 'gamble',
          });
        } else {
          setErrorMessage(result.message);
        }
      }
    } catch (err) {
      console.error('[TradeScreen] handleExecuteReservedOffer error:', err);
      setErrorMessage(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsProcessing(false);
    }
  };

  // 予約条件カード選択を確定
  const handleConfirmReservedCardSelection = async () => {
    if (!cardSelectionModal || isProcessing) return;

    setIsProcessing(true);
    setErrorMessage(null);

    try {
      if (isMerchantServerAvailable()) {
        // サーバーAPI経由で予約トレード実行
        const response = await completeReservationServer({
          selectedCards,
        });

        if (response.success) {
          setResultModal({
            success: true,
            receivedCards: response.received_cards,
            isGamble: cardSelectionModal.offer.type === 'gamble',
          });
        } else {
          setErrorMessage(response.error || '予約トレードの実行に失敗しました');
        }
      } else {
        // ローカルのみで処理
        const result = executeReservedOffer(
          playerData,
          selectedCards,
          collectionManager,
          allCards
        );

        if (result.success) {
          onPlayerDataUpdate(result.playerData);
          setResultModal({
            success: true,
            receivedCards: result.receivedCards,
            isGamble: cardSelectionModal.offer.type === 'gamble',
          });
        } else {
          setErrorMessage(result.message);
        }
      }
    } catch (err) {
      console.error('[TradeScreen] handleConfirmReservedCardSelection error:', err);
      setErrorMessage(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsProcessing(false);
      setCardSelectionModal(null);
      setSelectedCards([]);
    }
  };

  // ランダム挨拶
  const greeting = ZELVAN_GREETINGS[Math.floor(dayId * 17) % ZELVAN_GREETINGS.length];

  return (
    <div style={styles.container}>
      {/* ヘッダー */}
      <div style={{
        ...styles.header,
        padding: isMobile ? '10px 12px' : '12px 24px',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        gap: isMobile ? '8px' : '0',
      }}>
        <div style={{
          ...styles.headerLeft,
          gap: isMobile ? '10px' : '16px',
        }}>
          <button
            style={{
              ...styles.backButton,
              padding: isMobile ? '6px 12px' : '8px 16px',
              fontSize: isMobile ? '12px' : '14px',
            }}
            onClick={onBack}
            onMouseEnter={(e) => e.target.style.background = 'rgba(212,160,84,0.5)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(212,160,84,0.3)'}
          >
            ← 戻る
          </button>
          <span style={{
            ...styles.title,
            fontSize: isMobile ? '16px' : '24px',
          }}>
            🔄 カードトレード
          </span>
        </div>
        <div style={{
          ...styles.goldDisplay,
          fontSize: isMobile ? '14px' : '18px',
        }}>
          💰 {(playerData?.gold || 0).toLocaleString()} G
        </div>
      </div>

      {/* メインコンテンツ */}
      <div style={{
        ...styles.mainContent,
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '16px' : '24px',
        padding: isMobile ? '12px' : '24px',
      }}>
        {/* 左パネル: ゼルヴァン情報 */}
        <div style={{
          ...styles.leftPanel,
          width: isMobile ? '100%' : '300px',
        }}>
          <div style={{
            ...styles.merchantCard,
            padding: isMobile ? '14px' : '20px',
          }}>
            <div style={{
              ...styles.merchantHeader,
              gap: isMobile ? '12px' : '16px',
            }}>
              <div style={{
                ...styles.merchantIcon,
                fontSize: isMobile ? '36px' : '48px',
                width: isMobile ? '54px' : '70px',
                height: isMobile ? '54px' : '70px',
              }}>🎭</div>
              <div style={styles.merchantInfo}>
                <div style={{
                  ...styles.merchantName,
                  fontSize: isMobile ? '16px' : '20px',
                }}>ゼルヴァン</div>
                <div style={{
                  ...styles.merchantTitle,
                  fontSize: isMobile ? '11px' : '13px',
                }}>
                  放浪のトレーダー
                </div>
              </div>
            </div>
            <div style={{
              ...styles.greetingBox,
              padding: isMobile ? '12px' : '16px',
              fontSize: isMobile ? '12px' : '14px',
            }}>
              「{greeting}」
            </div>
          </div>

          {/* 予約中のオファー */}
          {reservedOffer && (
            <div style={styles.reservationSection}>
              <div style={styles.reservationTitle}>
                📋 予約中のオファー
              </div>
              <div style={styles.reservationInfo}>
                <div>タイプ: {OFFER_TYPE_ICONS[reservedOffer.offer.type]} {OFFER_TYPE_LABELS[reservedOffer.offer.type]}</div>
                <div>手付金: {reservedOffer.deposit.toLocaleString()}G</div>
                <div>期限: あと{Math.max(0, reservedOffer.expiresAt - dayId)}日</div>
              </div>
              <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button
                  style={{
                    ...styles.actionButton,
                    ...styles.primaryButton,
                    flex: 1,
                    padding: '10px',
                    fontSize: '13px',
                  }}
                  onClick={handleExecuteReservedOffer}
                >
                  実行
                </button>
                <button
                  style={{
                    ...styles.actionButton,
                    ...styles.dangerButton,
                    flex: 1,
                    padding: '10px',
                    fontSize: '13px',
                  }}
                  onClick={() => setConfirmCancelReservation(true)}
                >
                  キャンセル
                </button>
              </div>
            </div>
          )}

          {/* トレード統計 */}
          <div style={styles.statsSection}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#fff' }}>
              トレード統計
            </div>
            <div style={styles.statRow}>
              <span>総トレード数</span>
              <span style={{ color: '#fff' }}>{stats.totalTrades || 0}</span>
            </div>
            <div style={styles.statRow}>
              <span>お得トレード</span>
              <span style={{ color: '#66bb6a' }}>{stats.profitableTrades || 0}</span>
            </div>
            <div style={styles.statRow}>
              <span>ギャンブル勝利</span>
              <span style={{ color: '#ffd700' }}>{stats.gambleWins || 0}</span>
            </div>
            <div style={styles.statRow}>
              <span>ギャンブル敗北</span>
              <span style={{ color: '#ff6b6b' }}>{stats.gambleLosses || 0}</span>
            </div>
          </div>
        </div>

        {/* 右パネル: オファー一覧 */}
        <div style={styles.rightPanel}>
          <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#fff', marginBottom: '8px' }}>
            本日のトレードオファー ({offers.filter(o => !o.completed).length}件)
          </div>

          <div style={{
            ...styles.offerGrid,
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))',
          }}>
            {offers.length === 0 ? (
              <div style={styles.emptyMessage}>
                今日のオファーはありません
              </div>
            ) : (
              offers.map((offer) => {
                const colors = OFFER_TYPE_COLORS[offer.type] || OFFER_TYPE_COLORS.equal;
                const tradeable = canExecuteTrade(offer);

                return (
                  <div
                    key={offer.id}
                    style={{
                      ...styles.offerCard,
                      ...(offer.completed ? styles.offerCardCompleted : {}),
                    }}
                    onClick={() => !offer.completed && handleOpenOffer(offer)}
                    onMouseEnter={(e) => {
                      if (!offer.completed) {
                        e.currentTarget.style.border = '2px solid #d4a054';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.border = '2px solid #4a4a6a';
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    {offer.completed && (
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '48px',
                        opacity: 0.5,
                      }}>
                        ✅
                      </div>
                    )}

                    <div style={{
                      ...styles.offerTypeBadge,
                      background: colors.bg,
                      color: colors.text,
                    }}>
                      {OFFER_TYPE_ICONS[offer.type]} {OFFER_TYPE_LABELS[offer.type]}
                    </div>

                    {/* 渡すカード */}
                    <div style={styles.offerSection}>
                      <div style={styles.offerSectionTitle}>渡すカード</div>
                      {offer.giveType === 'specific' ? (
                        <div style={styles.cardList}>
                          {offer.give.slice(0, 3).map((item, i) => (
                            <div key={i} style={styles.cardListItem}>
                              <span style={{ color: RARITY_COLORS[item.rarity] }}>●</span>
                              <span>{getCardName(item.cardId)}</span>
                              <span style={{ color: '#808080' }}>×{item.count}</span>
                            </div>
                          ))}
                          {offer.give.length > 3 && (
                            <div style={{ color: '#808080', fontSize: '12px' }}>
                              ...他{offer.give.length - 3}種
                            </div>
                          )}
                        </div>
                      ) : (
                        <div style={styles.conditionBadge}>
                          {getConditionText(offer.giveCondition)} ×{offer.giveCondition.count}
                        </div>
                      )}
                    </div>

                    {/* もらうカード */}
                    <div style={styles.offerSection}>
                      <div style={styles.offerSectionTitle}>もらうカード</div>
                      {offer.receiveHidden ? (
                        <div style={styles.gambleHidden}>
                          🎲 トレードするまでわからない！
                        </div>
                      ) : (
                        <div style={styles.cardList}>
                          {offer.receive.slice(0, 3).map((item, i) => (
                            <div key={i} style={styles.cardListItem}>
                              <span style={{ color: RARITY_COLORS[item.rarity] }}>●</span>
                              <span>{getCardName(item.cardId)}</span>
                              <span style={{ color: '#808080' }}>×{item.count}</span>
                            </div>
                          ))}
                          {offer.receive.length > 3 && (
                            <div style={{ color: '#808080', fontSize: '12px' }}>
                              ...他{offer.receive.length - 3}種
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* トレード可能かどうかの表示 */}
                    {!offer.completed && (
                      <div style={{
                        marginTop: '8px',
                        padding: '6px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        textAlign: 'center',
                        background: tradeable ? 'rgba(76,175,80,0.2)' : 'rgba(244,67,54,0.2)',
                        color: tradeable ? '#66bb6a' : '#ff6b6b',
                      }}>
                        {tradeable ? '✓ トレード可能' : '✗ カードが不足'}
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>

      {/* オファー詳細モーダル */}
      {selectedOffer && (
        <div style={styles.modal} onClick={() => setSelectedOffer(null)}>
          <div style={{
            ...styles.modalBox,
            padding: isMobile ? '16px' : '24px',
            maxWidth: isMobile ? '340px' : '600px',
          }} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>
                {OFFER_TYPE_ICONS[selectedOffer.type]} {OFFER_TYPE_LABELS[selectedOffer.type]}
              </div>
              <button
                style={styles.closeButton}
                onClick={() => setSelectedOffer(null)}
                onMouseEnter={(e) => e.target.style.color = '#fff'}
                onMouseLeave={(e) => e.target.style.color = '#a0a0a0'}
              >
                ×
              </button>
            </div>

            {/* 渡すカード詳細 */}
            <div style={styles.detailSection}>
              <div style={styles.detailSectionTitle}>📤 渡すカード</div>
              {selectedOffer.giveType === 'specific' ? (
                <div style={styles.detailCardGrid}>
                  {selectedOffer.give.map((item, i) => {
                    const card = getCard(item.cardId);
                    return (
                      <div key={i} style={styles.detailCard}>
                        <div style={styles.detailCardName}>{card?.name || '不明'}</div>
                        <div style={{
                          ...styles.detailCardRarity,
                          color: RARITY_COLORS[item.rarity],
                        }}>
                          {RARITY_NAMES[item.rarity]}
                        </div>
                        <div style={styles.detailCardCount}>×{item.count}</div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div style={{
                  ...styles.conditionBadge,
                  padding: '12px 16px',
                  fontSize: '14px',
                }}>
                  {getConditionText(selectedOffer.giveCondition)} ×{selectedOffer.giveCondition.count}
                </div>
              )}
            </div>

            {/* もらうカード詳細 */}
            <div style={styles.detailSection}>
              <div style={styles.detailSectionTitle}>📥 もらうカード</div>
              {selectedOffer.receiveHidden ? (
                <div style={{
                  ...styles.gambleHidden,
                  padding: '24px',
                  fontSize: '16px',
                }}>
                  🎲 ギャンブル！結果はトレード後のお楽しみ
                </div>
              ) : (
                <div style={styles.detailCardGrid}>
                  {selectedOffer.receive.map((item, i) => {
                    const card = getCard(item.cardId);
                    return (
                      <div key={i} style={styles.detailCard}>
                        <div style={styles.detailCardName}>{card?.name || '不明'}</div>
                        <div style={{
                          ...styles.detailCardRarity,
                          color: RARITY_COLORS[item.rarity],
                        }}>
                          {RARITY_NAMES[item.rarity]}
                        </div>
                        <div style={styles.detailCardCount}>×{item.count}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* アクションボタン */}
            <div style={styles.actionButtons}>
              <button
                style={{
                  ...styles.actionButton,
                  ...styles.secondaryButton,
                }}
                onClick={() => setSelectedOffer(null)}
              >
                閉じる
              </button>
              {!reservedOffer && !canExecuteTrade(selectedOffer) && (
                <button
                  style={{
                    ...styles.actionButton,
                    ...styles.warningButton,
                    opacity: isProcessing ? 0.7 : 1,
                    cursor: isProcessing ? 'not-allowed' : 'pointer',
                  }}
                  onClick={handleReserve}
                  disabled={isProcessing}
                >
                  {isProcessing ? '処理中...' : `📋 予約する (${Math.ceil(selectedOffer.estimatedReceiveValue * RESERVATION_CONFIG.depositRate)}G)`}
                </button>
              )}
              <button
                style={{
                  ...styles.actionButton,
                  ...(canExecuteTrade(selectedOffer) && !isProcessing ? styles.primaryButton : styles.disabledButton),
                  opacity: isProcessing ? 0.7 : 1,
                  cursor: isProcessing || !canExecuteTrade(selectedOffer) ? 'not-allowed' : 'pointer',
                }}
                onClick={handleExecuteTrade}
                disabled={!canExecuteTrade(selectedOffer) || isProcessing}
              >
                {isProcessing ? '処理中...' : (canExecuteTrade(selectedOffer) ? '🔄 トレードする' : 'カード不足')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* カード選択モーダル（条件指定用） */}
      {cardSelectionModal && (
        <div style={styles.modal} onClick={() => {
          setCardSelectionModal(null);
          setSelectedCards([]);
        }}>
          <div style={{
            ...styles.modalBox,
            padding: isMobile ? '16px' : '24px',
            maxWidth: isMobile ? '340px' : '600px',
          }} onClick={e => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>
                渡すカードを選択
              </div>
              <button
                style={styles.closeButton}
                onClick={() => {
                  setCardSelectionModal(null);
                  setSelectedCards([]);
                }}
              >
                ×
              </button>
            </div>

            <div style={styles.conditionBadge}>
              条件: {getConditionText(cardSelectionModal.offer.giveCondition)}
            </div>

            <div style={styles.selectedCount}>
              選択中: {selectedCards.length} / {cardSelectionModal.requiredCount}
            </div>

            <div style={styles.cardSelectionGrid}>
              {cardSelectionModal.matchingCards.map((item, i) => {
                const isSelected = selectedCards.some(
                  s => s.cardId === item.cardId && s.rarity === item.rarity
                );
                return (
                  <div
                    key={`${item.cardId}_${item.rarity}_${i}`}
                    style={{
                      ...styles.selectableCard,
                      ...(isSelected ? styles.selectableCardSelected : {}),
                    }}
                    onClick={() => toggleCardSelection(item)}
                  >
                    <div style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                      color: '#fff',
                      marginBottom: '4px',
                    }}>
                      {item.card.name}
                    </div>
                    <div style={{
                      fontSize: '12px',
                      color: RARITY_COLORS[item.rarity],
                      marginBottom: '4px',
                    }}>
                      {RARITY_NAMES[item.rarity]}
                    </div>
                    <div style={{
                      fontSize: '11px',
                      color: '#808080',
                    }}>
                      所持: {item.quantity}
                    </div>
                    {isSelected && (
                      <div style={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px',
                        fontSize: '16px',
                      }}>
                        ✓
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            <div style={styles.actionButtons}>
              <button
                style={{
                  ...styles.actionButton,
                  ...styles.secondaryButton,
                  opacity: isProcessing ? 0.5 : 1,
                  cursor: isProcessing ? 'not-allowed' : 'pointer',
                }}
                onClick={() => {
                  if (!isProcessing) {
                    setCardSelectionModal(null);
                    setSelectedCards([]);
                  }
                }}
                disabled={isProcessing}
              >
                キャンセル
              </button>
              <button
                style={{
                  ...styles.actionButton,
                  ...(selectedCards.length === cardSelectionModal.requiredCount && !isProcessing
                    ? styles.primaryButton
                    : styles.disabledButton),
                  opacity: isProcessing ? 0.7 : 1,
                  cursor: isProcessing || selectedCards.length !== cardSelectionModal.requiredCount ? 'not-allowed' : 'pointer',
                }}
                onClick={cardSelectionModal.offer.isReservation
                  ? handleConfirmReservedCardSelection
                  : handleConfirmCardSelection
                }
                disabled={selectedCards.length !== cardSelectionModal.requiredCount || isProcessing}
              >
                {isProcessing ? '処理中...' : '確定'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 結果モーダル */}
      {resultModal && (
        <div style={styles.modal} onClick={() => setResultModal(null)}>
          <div style={{
            ...styles.modalBox,
            ...styles.resultModal,
            padding: isMobile ? '20px' : '32px',
            maxWidth: isMobile ? '340px' : '500px',
          }} onClick={e => e.stopPropagation()}>
            <div style={styles.resultIcon}>
              {resultModal.isGamble ? '🎲' : '🎉'}
            </div>
            <div style={styles.resultTitle}>
              トレード成立！
            </div>
            {resultModal.isGamble && (
              <div style={{
                background: 'rgba(255,215,0,0.2)',
                borderRadius: '8px',
                padding: '12px',
                marginBottom: '16px',
                color: '#ffd700',
                fontWeight: 'bold',
              }}>
                🎲 ギャンブル結果発表！
              </div>
            )}
            <div style={styles.resultCardList}>
              <div style={{ marginBottom: '12px', fontWeight: 'bold', color: '#4caf50' }}>
                獲得したカード:
              </div>
              {resultModal.receivedCards.map((item, i) => {
                const card = getCard(item.cardId);
                return (
                  <div key={i} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '8px',
                    padding: '8px',
                    background: 'rgba(0,0,0,0.3)',
                    borderRadius: '4px',
                  }}>
                    <span style={{ color: '#fff' }}>{card?.name || '不明'}</span>
                    <span>
                      <span style={{ color: RARITY_COLORS[item.rarity] }}>
                        {RARITY_NAMES[item.rarity]}
                      </span>
                      <span style={{ color: '#ffd700', marginLeft: '8px' }}>×{item.count}</span>
                    </span>
                  </div>
                );
              })}
            </div>
            <button
              style={{
                ...styles.actionButton,
                ...styles.primaryButton,
                width: '100%',
              }}
              onClick={() => setResultModal(null)}
            >
              閉じる
            </button>
          </div>
        </div>
      )}

      {/* 予約キャンセル確認モーダル */}
      {confirmCancelReservation && (
        <div style={styles.modal} onClick={() => setConfirmCancelReservation(false)}>
          <div style={{
            ...styles.modalBox,
            padding: '24px',
            maxWidth: '400px',
            textAlign: 'center',
          }} onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#fff', marginBottom: '16px' }}>
              予約をキャンセルしますか？
            </div>
            <div style={{ color: '#ff6b6b', marginBottom: '20px' }}>
              手付金 {reservedOffer?.deposit.toLocaleString()}G は没収されます
            </div>
            <div style={styles.actionButtons}>
              <button
                style={{
                  ...styles.actionButton,
                  ...styles.secondaryButton,
                }}
                onClick={() => setConfirmCancelReservation(false)}
              >
                戻る
              </button>
              <button
                style={{
                  ...styles.actionButton,
                  ...styles.dangerButton,
                  opacity: isProcessing ? 0.7 : 1,
                  cursor: isProcessing ? 'not-allowed' : 'pointer',
                }}
                onClick={handleCancelReservation}
                disabled={isProcessing}
              >
                {isProcessing ? '処理中...' : 'キャンセルする'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* エラーメッセージ表示 */}
      {errorMessage && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(90deg, rgba(200,50,50,0.95), rgba(150,30,30,0.95))',
          color: '#fff',
          padding: '12px 24px',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(200,50,50,0.4)',
          zIndex: 1100,
          fontSize: isMobile ? '13px' : '14px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <span>⚠️ {errorMessage}</span>
          <button
            onClick={() => setErrorMessage(null)}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '18px',
              padding: '0 4px',
            }}
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default TradeScreen;
